module.exports = __webpack_public_path__ + "static/you-cew-2-aa4bad2e5e3dc15a0fe4d36048d22722.jpg";